import type { ReactElement } from "react";
import React, { useCallback } from "react";
import Modal from "~/components/modal.tsx";
import useAppDispatch from "~/hooks/use-app-dispatch.ts";
import useAppSelector from "~/hooks/use-app-selector.ts";
import { selectUser } from "~/features/user/selectors.ts";
import { seenSignUpWelcome } from "~/features/user/store-slice.ts";

type JustSignedUpModalProps = {
	readonly show: boolean;
};

function JustSignedUpModal({ show }: JustSignedUpModalProps): ReactElement {
	const dispatch = useAppDispatch();
	const onSkip = useCallback(() => {
		dispatch(seenSignUpWelcome());
	}, [dispatch]);
	const user = useAppSelector(selectUser);
	const title = (() => {
		if (user.type === "signedIn" && user.user.firstName) {
			return `Welcome, ${user.user.firstName}!`;
		}
		return "Welcome!";
	})();

	return (
		<Modal
			title={title}
			show={show}
			slimBorder
			bodyClassName="just-signed-up-modal__body-tight"
		>
			<Modal.Text>
				Thanks for joining! You&apos;re all set - start by picking your image on
				the next page. We&apos;ve sent you an email to verify your account. You
				can keep going for now, but you&apos;ll need to verify before your next
				login. If you don&apos;t see the email, please check your spam folder.
			</Modal.Text>
			<Modal.Actions
				actions={[{ text: "Choose image", onClick: onSkip, type: "ghost" }]}
			/>
		</Modal>
	);
}

export default JustSignedUpModal;
